<template>
  <div>
    <div class="header-container">
      <RexBreadcrumbDropdownV3
        :routes="breadcrumbRoutes"
        @onClickEvent="goTo"
      />
      <RexSearch
        v-if="showSearchBar"
        :placeholder="getPlaceHolderText"
        @clearSelection="() => (searchInput = '')"
        @onTyping="
          (currentInput) => filterInstalledServices(currentInput.keyword)
        "
        width="30rem"
        class="search"
      />
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { useRoute } from 'vue-router';
import { TEMPLATE_INTEGRATIONS } from '@/utils/constants';
import RexBreadcrumbDropdownV3 from '@/rex-components/RexBreadcrumbDropdownV3.vue';
import RexSearch from '@/rex-components/rex-search.vue';
import { UPDATE_SEARCH_SERVICE } from '@/store/modules/cloud/connections/services.constants';

export default {
  components: {
    RexBreadcrumbDropdownV3,
    RexSearch,
  },
  data() {
    return {
      breadcrumbRoutes: [],
      searchInput: '',
    };
  },
  mounted() {
    this.setTemplate(TEMPLATE_INTEGRATIONS);
  },
  beforeMount() {
    const route = useRoute();
    this.updateBreadcrumbs(route);
  },
  watch: {
    $route: 'updateBreadcrumbs',
    searchInput: function (currentValue) {
      if (!currentValue) {
        this.filterInstalledServices(currentValue);
      }
    },
  },
  computed: {
    showSearchBar() {
      if (this.$route.fullPath.split('/').length === 4) return true;
      return false;
    },
    getPlaceHolderText() {
      return this.$t('aws.searchServices');
    },
  },
  methods: {
    ...mapMutations('globalState/app', ['setTemplate']),
    ...mapMutations('cloudState/connections', [UPDATE_SEARCH_SERVICE]),
    updateBreadcrumbs(route) {
      const routes = route.fullPath.split('/');
      const matchedRoutes = route.matched;
      const pathToRouteMapper = {
        integrations: 'integrationsComp',
        aws: 'awsSubscriptions',
      };
      if (matchedRoutes.length > 0) {
        this.breadcrumbRoutes = routes
          .filter((route) => route)
          .map((route) => {
            return {
              name: pathToRouteMapper[route],
              breadcrumbName: this.getBreadcrumbName(route),
            };
          });
      }
    },

    getBreadcrumbName(route) {
      const routeObj = {
        integrations: this.$t('integrations'),
        aws: this.$t('aws.awsConfigurations'),
      };

      if (route in routeObj) {
        return routeObj[route];
      } else {
        return route;
      }
    },
    goTo(route) {
      this.$router.push({
        name: route.name,
      });
    },
    checkLast(routes, route) {
      return routes.indexOf(route) === routes.length - 1;
    },
    filterInstalledServices(searchInput) {
      this.searchInput = searchInput;
      this[UPDATE_SEARCH_SERVICE](this.searchInput);
    },
  },
};
</script>

<style lang="scss" scoped>
.integrations {
  width: 100%;
  height: 100%;
}
.header-container {
  @include flex-center-justify(space-between);
  width: 100%;
}
.search {
}
</style>
